module.exports = __webpack_public_path__ + "img/AgusHaryadi.84fa6f79.jpeg";